import Modal from '@components/v2/ui/Modal/Modal';
import useMockLoading from '../../../../components/Hooks/useMockLoading';
import LangEnum from '../../../../lang/LangEnum';
import { OfflineTestIds } from '../../../../utils/testIds/Offline.testIds';
import { useTranslation } from '../../../translation/TranslationContext';
import OfflineSyncOrderModalContent from './components/OfflineSyncOrderModalContent';
import { OfflineSyncOrderModalParams } from './offlineSyncOrderModal.types';

const OfflineSyncOrderModal = ({
  isOpen,
  onClose,
  onSync,
  orderCode,
}: OfflineSyncOrderModalParams) => {
  const { translate } = useTranslation();

  // TODO: PRECISAMOS MELHORAR A TIPAGEM DO useMockLoading
  const { handleAsyncFunction: syncWithLoading, isLoading } = useMockLoading<undefined, void>({
    asyncFunction: onSync,
  });

  const title = orderCode
    ? translate(LangEnum.OFFLINE_SYNC_MODAL_TITLE, { code: orderCode })
    : translate(LangEnum.OFFLINE_SYNC_MODAL_TITLE_PLURAL);

  return (
    <Modal
      isOpen={isOpen}
      size="standard"
      header={{ title: title }}
      onClose={onClose}
      footer={{
        primaryAction: {
          isLoading,
          onClick: () => syncWithLoading(undefined),
          label: translate(LangEnum.GLOBAL_SYNC),
          testId: OfflineTestIds.CONFIRM_SYNC_OFFLINE_ORDER_BUTTON,
        },
        secondaryAction: {
          onClick: onClose,
          label: translate(LangEnum.GLOBAL_GO_BACK),
        },
      }}
    >
      <OfflineSyncOrderModalContent usePluralText={!orderCode} />
    </Modal>
  );
};

export default OfflineSyncOrderModal;
